import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles/scheduled.module.css';

const BettingButton = ({
  pickType,
  displayValue,
  isWatched,
  isLocked,
  isOtherLocked,
  hasReachedMaxPicks,
  hasRecentLineChange,
  isDisabled,
  isLoading,
  onClick,
  onKeyDown,
  ariaLabel
}) => {
  return (
    <button 
      className={`${styles.betButton} 
        ${isWatched ? styles.selected : ''}
        ${isLocked ? styles.locked : ''}
        ${isOtherLocked ? styles.otherLocked : ''}
        ${hasReachedMaxPicks && !isLocked && !isOtherLocked ? styles.maxReached : ''}
        ${hasRecentLineChange ? styles.lineChanged : ''}
        ${isDisabled ? styles.disabled : ''}`}
      onClick={onClick}
      onKeyDown={onKeyDown}
      disabled={isLoading || 
                isOtherLocked ||
                isLocked ||
                (hasReachedMaxPicks && !isLocked) ||
                isDisabled}
      aria-busy={isLoading}
      aria-label={ariaLabel}
    >
      {isLoading ? 'Loading...' : displayValue}
    </button>
  );
};

BettingButton.propTypes = {
  pickType: PropTypes.oneOf(['home', 'away', 'over', 'under']).isRequired,
  displayValue: PropTypes.string.isRequired,
  isWatched: PropTypes.bool.isRequired,
  isLocked: PropTypes.bool.isRequired,
  isOtherLocked: PropTypes.bool.isRequired,
  hasReachedMaxPicks: PropTypes.bool.isRequired,
  hasRecentLineChange: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired
};

export default BettingButton; 